import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  padding: 0;

  list-style: none;
`;

export const ListItem = styled.li``;

export const OptionButton = styled.button<{ $selected: boolean }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  padding: ${({ theme }) => theme.spacing(3)};
  margin: 0;
  width: 100%;

  border-radius: ${({ theme }) => theme.spacing(2)};
  border: 1px solid ${({ theme }) => theme.palette.divider};
  background: ${({ theme }) => rgba(theme.palette.common.white, 0.1)};
  cursor: pointer;

  @media (any-hover: hover) {
    transition: box-shadow 200ms;

    &:hover {
      box-shadow: 0 1px 2px 0
        ${({ theme }) => rgba(theme.palette.common.black, 0.04)};
    }
  }

  ${({ theme, $selected }) =>
    $selected &&
    css`
      border-color: transparent;
      box-shadow:
        0 1px 2px 0 ${rgba(theme.palette.common.black, 0.04)},
        0 0 0 3px ${theme.palette.primary.main};

      &:hover {
        box-shadow:
          0 1px 2px 0 ${rgba(theme.palette.common.black, 0.04)},
          0 0 0 3px ${theme.palette.primary.main};
      }
    `};
`;

export const OptionHeader = styled.span`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: flex-start;
`;

export const OptionMetaContainer = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const OldPrice = styled.span`
  text-decoration: line-through;
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Price = styled.span`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Period = styled.span`
  font-weight: ${({ theme }) => theme.typography.fontWeightRegular};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const CouponPrice = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.subtitle2)};
  text-decoration: line-through;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const OptionMetaList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const OptionMetaItem = styled.li`
  position: relative;
  display: flex;

  padding: ${({ theme }) => `0 0 0 ${theme.spacing(2)}`};

  color: ${({ theme }) => theme.palette.text.secondary};
  text-align: left;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0.7rem;
    left: 0;

    width: 0.4rem;
    height: 0.4rem;

    background: currentColor;
    border-radius: 50%;
  }
`;

export const UspTooltipIconContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
  color: ${({ theme }) => theme.palette.grey[600]};
  vertical-align: text-bottom;
`;

export const OptionBody = styled.span`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Discount = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: inline-block;
  padding: ${({ theme }) => `0 ${theme.spacing(2)}`};

  border-radius: ${({ theme }) => theme.spacing(6)};
  background: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundBackground};

  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
  white-space: nowrap;
`;
